<template>
    <v-row justify="center">
        <v-list-item

                color="primary"
                dark
                @click="getInterviewSchedule"
        >

            <v-list-item-icon>
                <v-img src="../../../../../assets/svg/complaint.svg" class="invite-box"></v-img>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title class="invite"> View Interview Schedule</v-list-item-title>
            </v-list-item-content>
        </v-list-item>


        <v-dialog
                v-model="dialog"
                width="450"

        >
            <v-card>

                <v-toolbar class="box"  @click.stop="dialog = false">
                    <v-icon>mdi-close</v-icon>
                    <v-toolbar-title>Close</v-toolbar-title>
                </v-toolbar>
                <div class="invite-content">
                    <div class="red--text">{{serverResponse}}</div>

                    <v-card-title class="comment-heading">Interview schedule </v-card-title>

                    <v-card-text class="comment-info">
                        {{applicant.firstName}} has been scheduled for:
                    </v-card-text>

                    <div class="schedule-box">
                        <Loader :loading="loading" :message="message"/>
                        <v-row>
                            <v-col sm="6">
                                <img src="../../../../../assets/svg/home.svg" alt="log" class="home-icon">

                            </v-col>
                            <v-col sm="6" >
                               <h5 v-if="interviewSchedule.accepted===false" class="pending"> PENDING </h5>
                                <h5 v-else-if="interviewSchedule.oldInterviewDate!==null && interviewSchedule.accepted===true" class="reschedule">RESCHEDULED</h5>
                                <h5 v-else-if="interviewSchedule.accepted===true" class="accept">ACCEPTED</h5>
                            </v-col>
                        </v-row>
                        <v-row>
                            <h6 class="ml-5">{{interviewSchedule.interviewDate}}</h6><span class="old">{{interviewSchedule.oldInterviewDate}}</span>
                        </v-row>


                        <v-row>
                            <h6 class="ml-5">{{interviewSchedule.interviewTime}}</h6><span class="old">{{interviewSchedule.oldInterviewTime}}</span>
                        </v-row>

                        <v-row>
                            <h6 class="ml-5 method">{{interviewSchedule.interviewMethod}}</h6>
                        </v-row>


                    </div>
                    <v-card-actions>
                        <v-btn
                                color="red"
                                outlined
                                x-large
                                @click="dialog = false"
                                class="ml-2"
                        >
                            Cancel
                        </v-btn>
                        <div @click="dialog=false">
                         <DecisionDialog ref="start" :server-response="serverResponse" />
                        </div>

<!--                        <v-btn-->
<!--                                color="error"-->
<!--                                depressed-->
<!--                                x-large-->
<!--                                @click="startInterview"-->
<!--                                class="ml-5"-->
<!--                        >-->
<!--                            Start Interview-->
<!--                        </v-btn>-->
                    </v-card-actions>

                </div>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import {mapGetters} from "vuex";
    import {getScheduleInvite} from "../../../../../services/ApiServices";
    import axios from 'axios'
    import Loader from "./Loader";
    import DecisionDialog from "./StartInterview";

    export default {
        name: "ViewInterviewSchedule",
        components: {DecisionDialog, Loader},
        data(){
            return{
                dialog:false,
                interviewSchedule:'',
                loading:false,
                message:'Loading...',
                interviewResponse:'',
                serverResponse:''
            }
        },
        methods:{
            getInterviewSchedule(){
                this.dialog=true;
                this.loading=true
                console.log(this.applicantEmail)
                const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
                axios.get(getScheduleInvite(this.applicantEmail),{headers:elderHeader})
                .then(res=>{
                    this.interviewSchedule = res.data
                    this.loading=false
                    console.log(res.data)
                })
                .catch(err=>{
                    console.log(err.response.data.message)
                    this.serverResponse=err.response.data.message
                    if( this.serverResponse===undefined){
                        this.serverResponse ="Check your internet connection and try again"
                    }


                    this.loading=false
                })
            }


        },
        computed: {

            ...mapGetters(['applicantEmail','applicant'])
        },
    }
</script>

<style scoped>
    .invite{
        font-family: IBM Plex Sans;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center !important;
        letter-spacing: 0.02em;
        color: #FF7E1D;
    }
    .invite-box{
        background: #FFDDD9;
        border-radius: 8px;
        padding: 3px;
    }
    .box{
        box-shadow: none!important;
        cursor: pointer;
    }
    .invite-content{
        margin-left: 55px;
        margin-right: 55px;
        font-family: IBM Plex Sans !important;
        font-style: normal!important;
        font-weight: normal;

    }
    .schedule-box{
        background: #FFFFFF;
        border: 1px solid #960C0C;
        box-sizing: border-box;
        box-shadow: 0px 4px 8px rgba(108, 132, 120, 0.15);
        border-radius: 8px;
        height: 180px;
        width: 300px;
        margin-left: 15px;
        margin-bottom: 30px;
    }
    .home-icon{
        width: 20px!important;
        margin-left: 10px !important;
    }
    .accept{
        background: #C3F7E8;
        border-radius: 8px;
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        width: 67%;
        padding-left: 8px!important;
        color: #00A998;


    }
    .pending{
        background: #D9D0E7;
        border-radius: 8px;
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        width: 65%;
        padding-left: 8px!important;
        color: #431288;


    }
    .reschedule{
        background: #FFDDD9;
        border-radius: 8px;
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        width:120px;
        padding-left: 8px!important;
        color: #FF7E1D;


    }
    .old{
        text-decoration: line-through !important;
        margin-left: 10px;
    }
    .method{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 25px;

        /* identical to box height, or 117% */
        display: flex;
        align-items: flex-end;

        color: #960C0C;
        margin-top: 10px !important;


    }

</style>